<template>
  <v-navigation-drawer v-model="computedValue" absolute right>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn icon v-on="on" @click="computedValue = false">
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </template>
      <span>Close</span>
    </v-tooltip>
    <v-card flat class="px-1">
      <v-select
        value="Node"
        dense
        hide-details
        :items="['Node']"
        outlined
        readonly
        class="mb-2"
      ></v-select>
      <NodeForm v-model="computedItem"></NodeForm>
    </v-card>
    <template #append>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined text color="error" @click="$emit('cancel')">cancel</v-btn>
        <v-btn outlined text color="primary" @click="$emit('save')">save</v-btn>
      </v-card-actions>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "VisualizationDrawer",
  components: {
    NodeForm: () => import("@/components/forms/VisNodeForm.vue"),
  },
  mixins: [],
  props: {
    value: { type: Boolean, required: false, default: true },
    item: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {};
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        if (!v) {
          this.$emit("cancel");
        }
      },
    },
    computedItem: {
      get() {
        return this.item;
      },
      set(v) {
        this.$emit("update:item", v);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
